module.exports = __webpack_public_path__ + "img/ИФ-1(А)-038.c1757034.png";